import React, { useEffect, useRef, useState } from "react";

// ASSETS

// STYLES
import { MapContainer, StyledMap } from "./MapStyled";

// LIBRARIES
import mapboxgl, { Map, Marker } from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";

// MISC
import { IProps } from "./MapModel";
mapboxgl.accessToken =
  "pk.eyJ1Ijoib3Jzb25hcGlrZXkiLCJhIjoiY2w4Y3Y4YXFrMTVmYzNxcGJnNnRpNXRvdCJ9.RaCSdr1r6sz6NpyL8vFwqA";

// REDUX

// COMPONENTS

const MapComponent = (props: IProps) => {
  // PROPERTIES
  const {
    mapCenter = {
      lat: 44.43859,
      lng: 26.09807,
    },
    marking = {
      lat: 44.43859,
      lng: 26.09807,
    },
    zoom = 17,
  } = props;
  // LIBRARY CONSTANTS
  const mapContainerRef = useRef<HTMLDivElement>(null);
  const [map, setMap] = useState<Map | null>(null);
  // STATE CONSTANTS

  // API REQUESTS

  // LIFE CYCLE
  useEffect(() => {
    if (mapContainerRef.current) {
      const initializeMap = () => {
        const initializedMap = new mapboxgl.Map({
          container: mapContainerRef.current!,
          style: "mapbox://styles/orsonapikey/cl8d64cck00ab14qqzkx2zawi",
          center: [mapCenter.lng, mapCenter.lat],
          zoom: zoom,
        });

        initializedMap.on("load", (event) => {
          setMap(initializedMap);

          new Marker()
            .setLngLat([marking.lng, marking.lat])
            .addTo(initializedMap);
        });
      };

      if (!map) initializeMap();
    }
  }, [map]);
  // EVENT HANDLERS

  return (
    <MapContainer>
      <StyledMap ref={mapContainerRef} />
    </MapContainer>
  );
};

export default MapComponent;
